/* PopUpDisplayComponent.js */

"use strict";

const EventEmitter = require('events').EventEmitter;
const Renderer = require("./PopUpDisplayRenderer");
const SteveRouter = require("@gluenetworks/steve_core_router");
const _ = require('lodash');

class PopUpDisplayComponent extends EventEmitter {


    constructor(configOptions) {
        super();
        this._router = new SteveRouter(window, window.history);
        this._shown = _.get(configOptions, 'shown', false);


        this._homeBarContext = _.get(configOptions, 'context', false);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){
        this._homeBarContext.addListener("ControlUserSet", this._onControlUserSet = this._onControlUserSet.bind(this));
        this._homeBarContext.addListener("ApplyInitialValues", this._applyInitialValues = this._applyInitialValues.bind(this));
        this._homeBarContext.addListener("LicensesSet", this._onLicensesSet = this._onLicensesSet.bind(this));
    }
    _unregisterListeners(){
        this._homeBarContext.removeListener("ControlUserSet", this._onControlUserSet);
        this._homeBarContext.removeListener("ApplyInitialValues", this._applyInitialValues);
        this._homeBarContext.removeListener("LicensesSet", this._onLicensesSet);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;

        this._shown = undefined;

        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    _onControlUserSet() {
        this.emit("ControlUserSet");
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/


    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

 
    setShown(newVal){
        this._shown = newVal;
        this.emit('Shown', this._shown);
        return this;
    }
    getShown(){
        return this._shown;
    }

    _applyInitialValues() {
        this.emit("ApplyInitialValues");
    }

    _onLicensesSet() {
        this.emit("LicensesSet");
    }
    /*
    setOrganizationsDisabled(newVal){
        this.emit('OrganizationsDisabled', newVal);
        return this;
    }*/
    
    
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = PopUpDisplayComponent;